export const EMAIL_STORAGE = "email_from_website"
